import db from './db';

export async function getOrCreateCustomer(sessionId) {
  let customer = await db.customers.where('sessionId').equals(sessionId).first();
  if (!customer) {
    const id = await db.customers.add({ sessionId });
    customer = { id, sessionId };
  }
  return customer;
}

export async function addProduct(customerId, productData) {
  return await db.products.add({
    customerId,
    ...productData
  });
}

export async function addPetPerson(petPersonData) {
  return await db.petsPeople.add({
    ...petPersonData,
    images: petPersonData.images
  });
}

export async function linkCustomerProductPetPerson(customerId, productId, petPersonId) {
  return await db.customerRelatedPetPerson.add({
    customerId,
    productId,
    petPersonId
  });
}

export async function getExistingPetsPeople() {
  return await db.petsPeople.toArray();
}

export async function getCartItems(customerId) {
    try {
      const products = await db.products.where('customerId').equals(customerId).toArray();
      console.log('Fetched products:', products);
      const relations = await db.customerRelatedPetPerson.where('customerId').equals(customerId).toArray();
      console.log('Fetched relations:', relations);
  
      const cartItems = await Promise.all(products.map(async (product) => {
        const relation = relations.find(r => r.productId === product.id);
        console.log(`Relation for product ${product.id}:`, relation);
        const petPerson = relation ? await db.petsPeople.get(relation.petPersonId) : null;
        console.log(`Fetched pet person for relation ${relation?.id}:`, petPerson);
        return { ...product, petPerson };
      }));
  
      console.log('Final cart items:', cartItems);
      return cartItems;
    } catch (error) {
      console.error('Error fetching cart items:', error);
      throw error;
    }
  }

  // Add this function to dbOperations.js

export async function checkImagesExistence(base64Images) {
    const existingImages = await db.petsPeople.toArray();
    const allExistingImages = existingImages.flatMap(pet => pet.images);
  
    return base64Images.map(newImage => ({
      base64: newImage,
      exists: allExistingImages.includes(newImage)
    }));
  }


  // Add this to dbOperations.js

// Add this to dbOperations.js

// Add this to dbOperations.js

